import React, { useState,useEffect,useRef} from 'react';
import { useParams } from 'react-router-dom';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PageINFpodglad = () => {
  const { klasyfikacja, rok, examId } = useParams();
  const [pdfUrl, setPdfUrl] = useState('');

  useEffect(() => {
    function convertFileName() {
      let part1 = '';
      if (klasyfikacja === "INF03") {
        part1 = "inf3";
      } else if (klasyfikacja === "EE09") {
        part1 = "ee9";
      } else if (klasyfikacja === "E14") {
        part1 = "e14";
      }
      else if (klasyfikacja === "INF04") {
        part1 = "inf4";
      }

      const shortYear = rok.slice(2);
      const parts = examId.split('_');
      const [prefix, year, month, number] = parts;

      const monthMap = {
        styczen: 'st',
        czerwiec: 'cz'
      };
      const shortMonth = monthMap[month] || month;

      return `${part1}_${shortMonth}${shortYear}_prak${number}.pdf`;
    }

    const zmienna = convertFileName();
    const newPdfUrl = `https://raw.githubusercontent.com/PumaYT22/EgzaminyZawodoweINF/main/Egzaminy/${klasyfikacja}/${rok}/${examId}/arkusz/${zmienna}`;
    setPdfUrl(newPdfUrl);
  }, [klasyfikacja, rok, examId]);

  return (
    <div>
      <h1>Podgląd arkusza</h1>
      {pdfUrl && (
        <div>
          <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
            <Viewer fileUrl={pdfUrl} />
          </Worker>
        </div>
      )}
    </div>
  );
};

export default PageINFpodglad;